<p-dialog header="{{ 'Content'|translate }}" [(visible)]="!!display" [style]="{width: '900px'}" [resizable]="true" position="top" (onShow)="onShow()">
  <iframe id="attachmentViewer" style="width: 100%;height: 70vh;"></iframe>
  <p-footer>
    <p-button label="{{ 'Print'|translate }}" icon="pi pi-print" styleClass="p-button-raised p-button-info" (onClick)="print()"></p-button>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="display=0"></p-button>
  </p-footer>
</p-dialog>
